export default function parseErrorData(data) {
  let parsed;
  try {
    parsed = data ? JSON.parse(data) : null;
  } catch (e) {
    parsed = null;
  }
  return parsed;
}
export const getParsedErrorData = error => {
  let dataMessage;
  let dataStatus;
  if (error.data) {
    const parsed = parseErrorData(error.data);
    dataMessage = parsed.message;
    dataStatus = parsed.status;
  }
  return {
    dataMessage,
    dataStatus
  };
};